import { render, staticRenderFns } from "./IconColumnCenter.vue?vue&type=template&id=18f36e11&"
import script from "./IconColumnCenter.vue?vue&type=script&lang=js&"
export * from "./IconColumnCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f36e11')) {
      api.createRecord('18f36e11', component.options)
    } else {
      api.reload('18f36e11', component.options)
    }
    module.hot.accept("./IconColumnCenter.vue?vue&type=template&id=18f36e11&", function () {
      api.rerender('18f36e11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconColumnCenter.vue"
export default component.exports